<div class="details-container" [ngClass]="{ 'archive-mode': isArchiveMode }">
    <div class="top-container">
        <app-favorites-bar class="details-item details-item-favorites" [favoriteAttributesDefinitions]="favoriteAttributesDefinitions" [folder]="folder"></app-favorites-bar>
        <app-folder-detail-menu
            [readonly]="readonly"
            [isInStandbyState]="folder.isInStandByState"
            [isInWaitingArchivingState]="folder.isInWaitingArchivingState"
            [hasWarning]="hasWarning"
            [isFollowed]="folder.isFollowed"
            (actionRequested)="onActionRequest($event)"
            (navigationRequested)="onNavigationRequested($event)"></app-folder-detail-menu>
    </div>
    <div class="bottom-container">
        <app-sections-container
            [folder]="folder"
            [view]="view"
            [attributesDefinitions]="attributesDefinitions"
            [readonly]="readonly"
            (documentDeleted)="onDocumentDeletion($event)"
            (mailReplied)="onMailReplied($event)"
            (mailResended)="onMailResended($event)"></app-sections-container>
    </div>
</div>
